import extend from 'extend'
import expandToDefaultProps from './expandToDefaultProps'

// 深度复制对象到构造器上
// 改变原构造器
const restructureVueCtor = (originalCtor, additionalOptions = {}) => extend(true, originalCtor, additionalOptions)

// 扩展options上的配置为Vue构造器的默认props值
export const restructureDefaultPropsOfVueCtorFromOptions = (originalCtor, options = {}) => restructureVueCtor(originalCtor, {
  props: expandToDefaultProps(options)
})

export {
  restructureVueCtor
}

export default restructureVueCtor



// WEBPACK FOOTER //
// ./src/packages/utils/src/restructureVueCtor.js